import { Action, Actions } from "./userActions";
import { UserState } from "./userState";

export default (state: typeof UserState, action: Action): typeof UserState => {
  switch (action.type) {
    case Actions.FETCHING_USER_STATUS: {
      return {
        ...state,
        fetchingUser: true,
      };
    }
    case Actions.USER_STATUS_FETCHED: {
      return {
        ...state,
        user: action.payload,
        fetchingUser: false,
        userFetched: true,
      };
    }
    case Actions.FETCHING_ONBOARDING_STATUS: {
      return {
        ...state,
        fetchingOnboardingDetails: true,
      };
    }
    case Actions.ONBOARDING_STATUS_FETCHED: {
      return {
        ...state,
        onboardingDetails: action.payload,
        fetchingOnboardingDetails: false,
        onboardingDetailsFetched: true,
      };
    }
    case Actions.FETCHING_PAYROLL_PROVIDERS: {
      return {
        ...state,
        fetchingPayrollProviders: true,
      };
    }
    case Actions.PAYROLL_PROVIDERS_FETCHED: {
      return {
        ...state,
        payrollProviders: action.payload,
        fetchingPayrollProviders: false,
        payrollProvidersFetched: true,
      };
    }
    case Actions.FETCHING_RECORD_KEEPERS_LIST: {
      return {
        ...state,
        fetchingRecordKeeperList: true,
      };
    }
    case Actions.RECORD_KEEPERS_LIST_FETCHED: {
      return {
        ...state,
        fetchingRecordKeeperList: false,
        recordKeeperList: action.payload,
        recordKeeperListFetched: true,
      };
    }
    case Actions.CLEAR_DATA: {
      return {
        ...UserState,
      };
    }
    case Actions.UPDATE_INTEGRATION: {
      return {
        ...state,
        isHRISConnected: action.payload,
      };
    }
    default:
      return state;
  }
};
